// IMPORTS
// schema
import * as ISchema from "@schema";

import { commitMutation } from "react-relay";
import { Environment } from "relay-runtime";
import { addAndRemoveOrgTagsMutation } from "./AddAndRemoveOrgTags.gql";
import { addUserTags, removeUserTags } from "./";
import { modernCache } from "@network/modern-network-layer";

// TYPES
interface IAddAndRemoveUserTagsMutationResponse {
  addAndRemoveOrgTags: ISchema.IAddAndRemoveOrgTagsMutationPayload;
}

// pick which mutation to use based on the inputs
export function addAndRemoveUserTags(
  environment: Environment,
  input: ISchema.IAddAndRemoveOrgTagsMutationInput,
  onSuccess: (response?: any) => void,
  onError: (error?: any) => void,
) {
  const needsAdd = input.tagsToAdd && input.tagsToAdd.length > 0;
  const needsRemove = input.tagNamesToRemove.length > 0;

  if (needsAdd && needsRemove) {
    addAndRemove(environment, input, onSuccess, onError);
  } else if (needsRemove) {
    removeUserTags(
      environment,
      input.orgRelayId,
      input.eventParentRelayId,
      input.tagNamesToRemove,
      onSuccess,
      onError,
    );
  } else if (needsAdd) {
    addUserTags(
      environment,
      input.orgRelayId,
      input.eventParentRelayId,
      input.tagsToAdd,
      onSuccess,
      onError,
    );
  }
}

// the actualy add and remove mutation
function addAndRemove(
  environment: Environment,
  input: ISchema.IAddAndRemoveOrgTagsMutationInput,
  onSuccess: (response?: ISchema.IAddAndRemoveOrgTagsMutationPayload) => void,
  onError: (error?: any) => void,
) {
  commitMutation(environment, {
    onError,
    mutation: addAndRemoveOrgTagsMutation,
    variables: { input },
    onCompleted: (_response: IAddAndRemoveUserTagsMutationResponse, errors?: Error[]) => {
      if (!!errors) {
        onError(errors[0]);
      } else {
        // if we're not in a modern environment, modernCache will be undefined
        if (modernCache) {
          modernCache.clear();
        }
        onSuccess();
      }
    },
  });
}
